module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_boa.6ac1d094.png";